<template>
  <div class="overview">
    <div class="overview__header">
      <img v-if="getProvinceSetting.logo" :src="getProvinceSetting.logo" :alt="getProvinceSetting.name" class="overview__header-img">
      <h1 v-else>{{ getProvinceSetting.name }}</h1>
      <div v-if="queryArgs.menu !== '0'" class="overview__header-menu">
        <span v-if="!menuActive && newValues.length" class="new-dictrict-notification">
          <strong>{{ newValues[newValues.length - 1].title._text }}</strong> heeft nieuwe uitslagen
        </span>
        <div 
          :style="{backgroundColor: getProvinceSetting.color}"
          :class="['overview__menu-toggle']" 
          @click="toggleMenu">
          <span v-for="i in 3" :key="i" :class="['menu-bar', {active: menuActive}]"/>
          <div v-if="!menuActive && newValues.length" class="overview__menu-bubble">
            {{ newValues.length }}
          </div>
        </div>
      </div>
    </div>
    <!-- Wait till the first feed is collected and filled -->
    <div v-if="communities" :class="['overview__body', {'list-view': !mapMode}]">
      <div class="overview__stats">
        <ProvincialStatistics :district="selectedDistrict" @toggleDistrict="selectedDistrict = null"/>
      </div>
      <div v-if="queryArgs.menu !== '0'" :class="['overview__menu', {active: menuActive}]">
        <div class="overview__menu-container">
          <div v-if="menuActive" class="overview__menu-background-toggle" @click="menuActive = false"/>
          <div class="overview__menu-header">
            <h2>Menu</h2>
            <div class="overview__menu-map-toggle">
              <span>Overzicht</span>
              <Checkbox :toggle-texts="['Lijst', 'Kaart']" v-model="mapMode" model="slide" mode="always-on" @input="mapMode = $event" />
            </div>
          </div>
          <div v-show="!mapMode" class="overview__menu-recent-districts">
            <DistrictSearch @onSelect="selectDistrict" />
            <div class="overview__menu-list-container">
              <h3>Uitslagen gemeente</h3>
              <strong class="text--subtitle">Meest recent</strong>
              <div :class="['overview__menu-items districts', {disabled: loading.district || loading.updating}]">
                <div v-for="(val, key) in communitiesByDate" :key="key" 
                     :style="{color: selectedDistrict && selectedDistrict.title._attributes.cbs === val.title._attributes.cbs ? getProvinceSetting.color : 'inherit'}"
                     :class="['overview__menu-item']"
                     @click="selectDistrict(val)">
                  <span 
                    v-if="hasUpdate(val.title._attributes.cbs)"
                    :style="{backgroundColor: getProvinceSetting.color}" 
                    class="overview__menu-item--new"/>
                  <span class="timestamp">{{ $dateToTime(val.pubDate._text) }}</span> {{ val.title._text }}
                </div>
              </div>
              <h2>Zetelverdeling</h2>
              <div class="overview__menu-items">
                <div 
                  :style="{color: !selectedDistrict ? getProvinceSetting.color : 'inherit'}"
                  :class="['overview__menu-item']"
                  @click="selectedDistrict = null"
                ><span class="timestamp">{{ seatsUpdateTime }}</span>Totaal stemmen</div>
              </div>
            </div>
          </div>
          <ProvincialMap v-show="mapMode" ref="provincialMap" class="overview__menu-provincial-map" @onselect="pickDistrictFromMap" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ProvincialMap from "../components/ProvincialMap.vue";
import Checkbox from "../components/elements/Checkbox.vue";
import ProvincialStatistics from "../components/ProvincialStatistics.vue";
import DistrictSearch from "../components/DistrictSearch.vue";
import Spinner from "../components/Spinner.vue";
export default {
  name: "Overview",
  components: {
    ProvincialMap,
    ProvincialStatistics,
    Spinner,
    Checkbox,
    DistrictSearch
  },
  data() {
    return {
      menuActive: window.innerWidth > 1679,
      selectedDistrict: null,
      mostRecent: null,
      newValues: [],
      mapMode: false
    };
  },
  computed: {
    ...mapState({
      communities: state => state.feed.communities,
      loading: state => state.feed.loading,
      provincialData: state => state.feed.provincialData,
      queryArgs: state => state.route.query
    }),
    ...mapGetters("feed", ["getProvinceSetting"]),
    communitiesByDate() {
      const comms = this.communities[this.getProvinceSetting.key];

      return Object.values(comms).sort(
        (a, b) => new Date(b.pubDate._text) - new Date(a.pubDate._text)
      );
    },
    hasUpdate: ctx => cbs => {
      if (ctx.newValues.length) {
        return !!ctx.newValues.find(v => v.title._attributes.cbs === cbs);
      }
      return null;
    },
    seatsUpdateTime() {
      const stamp = this.provincialData.seats.Uitslag.PublicatieDatumTijd._text;
      const time = stamp.substring(stamp.indexOf("+"), 0).split("T")[1];
      return `${time.substring(0, 2)}:${time.substring(2, 4)}`;
    }
  },
  watch: {
    communities: {
      handler() {
        // Check for values that are new and merge them within this.newValues
        if (this.mostRecent) {
          this.newValues = [
            ...this.newValues,
            ...this.communitiesByDate.filter(
              v => new Date(v.pubDate._text) > new Date(this.mostRecent)
            )
          ];
        }
        this.$nextTick(() => {
          this.$refs.provincialMap.updateCommunities();
          this.mostRecent = this.communitiesByDate[0].pubDate._text;
        });
      },
      immediate: true
    }
  },
  methods: {
    selectDistrict(val, cb = null) {
      // select new district and remove 'new' state from newValues
      if (!this.loading.district && !this.loading.updating) {
        this.selectedDistrict = JSON.parse(JSON.stringify(val));
        this.newValues = this.newValues.filter(
          d => d.title._attributes.cbs !== val.title._attributes.cbs
        );
        if (typeof cb === "function") {
          cb();
        }
      }
    },
    pickDistrictFromMap(cbs) {
      // doesnt execute when polling
      this.selectDistrict(
        this.communities[this.getProvinceSetting.key][cbs.replace("G", "")]
      );
    },
    toggleMenu() {
      this.menuActive = !this.menuActive;
      if (!this.menuActive) {
        this.$nextTick(() => {
          this.newValues = [];
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "../util.scss";
// define width of map and list view of the menu
$menu-width-list: 380px;
$menu-width-map: 560px;
.overview {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  max-width: 100vw;
  min-width: 720px;
  height: 100vh;
  background-color: $grey;

  &__header {
    background-color: $white;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    min-height: 62px;
    position: relative;
    border-bottom: 2px solid $border;

    h1 {
      position: absolute;
      left: 50%;
      top: 50%;
      margin: 0;
      transform: translate(-50%, -50%);
    }
  }
  &__header-img {
    max-height: 34px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    @include respond-to("medium-small") {
      left: 12px;
      transform: translateY(-50%);
      width: 200px;
    }
  }
  &__header-menu {
    display: flex;
    align-items: center;

    .new-dictrict-notification {
      margin-right: 12px;
    }
  }
  &__body {
    display: flex;
    height: 100%;
    position: relative;
    align-items: flex-start;
    overflow: auto;
  }
  &__stats {
    max-width: 100%;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: auto;

    @include respond-to("large") {
      width: 100% !important;
    }
  }
  // change width of menu depending on list or map view
  .overview__body.list-view {
    .overview__menu {
      max-width: $menu-width-list;
      min-width: $menu-width-list;
    }

    &-container {
      min-width: calc(#{$menu-width-list} - 40px);
    }
  }
  &__menu {
    max-width: $menu-width-map;
    min-width: $menu-width-map;
    flex: 1;
    background-color: white;
    margin: 0 0 0 12px;
    transition: 300ms all ease-in-out;
    padding: 20px;
    box-shadow: 1px 1px 8px 0px rgba(0, 0, 0, 0.4);

    @include respond-to("large") {
      position: fixed;
      z-index: 10;
      right: 0;
      top: 62px;
      bottom: 0;
      margin: 0;
      box-shadow: none;
      border-left: 1px solid $border;

      &-background-toggle {
        position: absolute;
        right: 100%;
        top: 0;
        bottom: 0;
        left: calc((100vw - 100%) * -1);
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;
      }
    }

    &-bubble {
      position: absolute;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: red;
      text-align: center;
      font-weight: bold;
      color: white;
      line-height: 20px;
      display: block;
      right: -7px;
      top: -7px;
    }

    &-recent-districts {
      min-width: calc(#{$menu-width-list} - 40px);
    }
    &-provincial-map {
      min-width: calc(#{$menu-width-map} - 40px);
    }

    &-container {
      min-width: 100%;
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    &-list-container {
      max-height: calc(100vh - 240px);
      overflow: auto;
    }

    &:not(.active) {
      max-width: 0 !important;
      min-width: 0 !important;
      padding: {
        left: 0;
        right: 0;
      }
      margin-left: 0;
      overflow: hidden;
      transition: 300ms all ease-in-out;
    }

    &-toggle {
      width: 36px;
      height: 36px;
      border-radius: 6px;
      color: $white;
      display: flex;
      cursor: pointer;
      position: relative;
      .menu-bar {
        position: absolute;
        width: calc(100% - 18px);
        height: 3px;
        left: 9px;
        background-color: white;
        transition: 200ms ease-in-out all;

        &:nth-child(1) {
          top: 11px;
        }
        &:nth-child(2) {
          top: 17px;
        }
        &:nth-child(3) {
          top: 23px;
        }
        &.active {
          transition: 200ms ease-in-out all;
          &:nth-child(2) {
            opacity: 0;
          }

          &:nth-child(1),
          &:nth-child(3) {
            top: calc(50% - 1px);
            transform: translateY(-50%);
          }

          &:nth-child(1) {
            transform: rotate(45deg);
          }
          &:nth-child(3) {
            transform: rotate(-45deg);
          }
        }
      }
    }

    &-map-toggle {
      display: flex;
      align-items: center;
      span {
        margin-right: 12px;
        font-weight: bold;
      }
    }

    &-header {
      padding-bottom: 12px;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: calc(380px - 40px);

      h2 {
        font-size: 30px;
        margin: 0;
        font-weight: 500;
      }

      &:after {
        content: "";
        display: block;
        left: -20px;
        right: -20px;
        background-color: $border;
        height: 2px;
        position: absolute;
        bottom: 0;
      }
    }

    h3 {
      // margin-bottom: 0;
      font-size: 23px;
    }

    &-items {
      margin: 12px 0 26px;

      &.districts {
        max-height: calc(100vh - 450px);
        overflow: scroll;
      }
      &.disabled {
        opacity: 0.5;
      }
    }

    &-item {
      cursor: pointer;
      padding: 16px 0 16px 0px;
      position: relative;
      margin-left: 20px;
      &--new {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $primary;
        position: absolute;
        left: -18px;
        top: 50%;
        transform: translateY(-50%);
      }
      &.active {
        color: $primary;
      }
      .timestamp {
        margin-right: 15px;
        font-weight: bold;
        font-size: 15px;
      }
    }
  }
}
</style>
